export enum TopicalRiskViews {
  Details = 'details',
  Trends = 'trends',
}

export enum LegacyTopicalRiskViews {
  ImmediateAttention = 'immediate-attention',
  FullScope = 'full-scope',
}

const TOPICAL_RISK_VIEWS: string[] = Object.values(TopicalRiskViews)

export const isTopicalRiskView = (view: string | undefined): view is TopicalRiskViews =>
  view !== undefined && TOPICAL_RISK_VIEWS.includes(view)
